module.exports = __webpack_public_path__ + "img/cus_hover8.2121c814.svg";